import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Análisis inicial',
  description: 'Revisión de tu situación actual, objetivos y oportunidades.'
}, {
  number: '02',
  title: 'Planificación estratégica',
  description: 'Definición de canales, audiencias, mensajes y presupuesto.'
}, {
  number: '03',
  title: 'Lanzamiento y monitoreo',
  description: 'Ejecución de campañas con seguimiento en tiempo real.'
}, {
  number: '04',
  title: 'Optimización continua',
  description: 'Ajustes basados en datos para mejorar resultados constantemente.'
}];
export function Methodology() {
  return <section id="metodologia" className="py-20 md:py-28 bg-slate-50" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="text-center mb-16" data-id="element-92">
          <span className="text-blue-600 font-semibold tracking-wide uppercase text-sm" data-id="element-93">
            Proceso
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mt-2" data-id="element-94">
            Cómo trabajamos
          </h2>
        </div>

        <div className="relative" data-id="element-95">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-slate-200 -z-10" data-id="element-96"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8" data-id="element-97">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2,
            duration: 0.5
          }} className="relative bg-slate-50 md:bg-transparent" data-id="element-98">
                <div className="w-24 h-24 bg-white rounded-full border-2 border-slate-100 flex items-center justify-center text-3xl font-bold text-blue-600 shadow-sm mb-6 mx-auto md:mx-0 z-10 relative" data-id="element-99">
                  {step.number}
                </div>
                <div className="text-center md:text-left" data-id="element-100">
                  <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-101">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-102">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}